import styled from 'styled-components';

interface BlueGlowOrbProps {
  readonly size: number;
  readonly top?: string;
  readonly bottom?: string;
  readonly left?: string;
  readonly right?: string;
  readonly blur?: number; // blur in rem (default: 1.2rem = 12px)
}

export const BlueGlowOrb = styled.div<BlueGlowOrbProps>`
  position: absolute;
  width: ${({ size }) => size}rem;
  height: ${({ size }) => size}rem;
  top: ${({ top }) => top};
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  border-radius: 50%;
  pointer-events: none;
  background: linear-gradient(283deg, #02adef 5%, #719cf9 93.75%);
  filter: blur(${({ blur = 1.2 }) => blur}rem);
`;

interface BlueFadedOrbProps {
  readonly width: number; // width in rem
  readonly height: number; // height in rem
  readonly top?: string;
  readonly bottom?: string;
  readonly left?: string;
  readonly right?: string;
}

export const BlueFadedOrb = styled.div<BlueFadedOrbProps>`
  position: absolute;
  width: ${({ width }) => width}rem;
  height: ${({ height }) => height}rem;
  top: ${({ top }) => top};
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  border-radius: ${({ width }) => width}rem;
  pointer-events: none;
  background: radial-gradient(50% 50% at 50% 50%, #02adef 0%, rgba(21, 28, 43, 0) 100%);
`;
